<template>
    <div>
        <ion-item>
            <ion-img :src="src"></ion-img>
        </ion-item>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button color="primary" expand="block" fill="outline" size="small" v-on:click="selectPhoto">
                        <ion-icon slot="start" color="primary" ios="ios-camera" md="md-camera"/> Take Photo
                    </ion-button>
                </ion-col>  
                <ion-col>
                    <ion-button color="danger" expand="block" fill="outline" size="small" :disabled="src===placeholder" v-on:click="removePhoto">
                        <ion-icon slot="start" color="danger" ios="ios-trash" md="md-trash"/> Remove Photo
                    </ion-button>
                </ion-col>      
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import Plugins from "../mixins/Plugins";
import Field from "../models/Field";
import Value from "../models/Value";
export default {
    name: "field-image",
    mixins: [
        Plugins
    ],
    components: {},
    props: ["field", "value"],
    data() {
        return {
            src: null
        };
    },
    computed: {
        placeholder () {
            return require('../assets/photo.png');
        }
    },
    created() {
        this.src = this.placeholder;
    },
    methods: {
        async selectPhoto() {
            let base64 = await this.takePicture();
            if (base64 && base64.length > 0) {
                this.src = base64;
                this.value.value = base64;
            }
        },
        removePhoto() {
            this.src = this.placeholder;
            this.value.value = "";
        }
    }
}
</script>

<style scoped>
ion-img {
    width: 100%;
}
</style>